import { useEffect } from 'react';

import { useItemPopup } from 'features/add-item/form/useItemPopup';
import { ROUTE_ITEMS } from 'navigation/config/routesConfig';

import { HotDeals } from './HotDeals';

export const NewItem = () => {
  const { showAddItemPopup } = useItemPopup();

  useEffect(() => {
    window.history.replaceState(null, '', ROUTE_ITEMS);
    const clock = setTimeout(showAddItemPopup, 750);
    return () => clearTimeout(clock);
  }, []);

  return <HotDeals />;
};
